import { CommonHelper } from "../helpers";
export default {
  setClientInformation(payload) {
    return payload.map((r) => {
      let p = {};
      p.clientName = CommonHelper.stringtoPascal(r.clientName);
      p.partnerName = r.partnerName;
      p.entityType = r.entityType;
      p.firstName = CommonHelper.stringtoPascal(r.firstName);
      p.lastName = CommonHelper.stringtoPascal(r.lastName);
      p.clientId = r.clientId;
      p.ownerShort = r.ownerShort;
      p.encryptedClientId = r.encryptedClientId;
      p.superFundTypeId = r.superFundTypeId;
      p.dob = r.dob;
      p.gender = r.gender;
      p.preferedName =
        CommonHelper.stringtoPascal(r.firstName) +
        CommonHelper.stringtoPascal(r.lastName);
      return p;
    });
  },
};
